module.exports = __webpack_public_path__ + "media/images/users/calender-b5437b6efa68b2c5e05722c5adac4699.png";